import { createSlice } from '@reduxjs/toolkit';

export const runTestsSlice = createSlice({
  name: 'runTests',
  initialState: {
    data: {},
    originalTree: [],
    currentTree: [],
    selectedUrls: [],
    selectedKeys: {},
    //IMPORTANT: the order of these filters should match the order of the nodes in the tree
    filters: [
      {
        name: 'application',
        value: [],
        data: null,
      },
      {
        name: 'client',
        value: [],
        data: null,
      },
      {
        name: 'template',
        value: [],
        data: null,
      },
      {
        name: 'siteEdition',
        value: [],
        data: null,
      },
      {
        name: 'url',
        value: [],
        data: null,
      },
      {
        name: 'component',
        value: [],
        data: null,
      },
    ],
  },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    },
    updateData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    clearData: (state) => {
      state.data = {};
    },
    setSelectedUrls: (state, action) => {
      state.selectedUrls = action.payload;
    },
    setDefaultSelected: (state, action) => {
      state.defaultSelected = action.payload;
    },
    setSelectedKeys: (state, action) => {
      state.selectedKeys = action.payload;
    },
    setOriginalTree: (state, action) => {
      state.originalTree = action.payload;
    },
    setCurrentTree: (state, action) => {
      state.currentTree = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
});

export const {
  setData,
  updateData,
  clearData,
  setSelectedUrls,
  setDefaultSelected,
  setSelectedKeys,
  setOriginalTree,
  setCurrentTree,
  setFilters,
} = runTestsSlice.actions;

export default runTestsSlice.reducer;
